import { useEffect, useState } from "react";
import LinkToGroupManagement from "./LinkToGroupManagement.jsx";
import { LoadCurrentUserPointsGroups } from "../repo/GroupsRepo.js";

export default function MatchesList({groupId}) {
  const [currentUserPoints, setCurrentUserPoints] = useState([])

  async function loadCurrentUserPoints(groupId) {
    const resData = await LoadCurrentUserPointsGroups(groupId)

    setCurrentUserPoints(resData.data)
  }

  useEffect(() => {
    if (groupId) {
      loadCurrentUserPoints(groupId)
    }
  }, [groupId])

  return (
    <>
      {groupId && (
        <div className="py-4 mx-4 text-center lg:text-right">
          Posição: <b>{currentUserPoints.position}</b> / Pontos: <b>{currentUserPoints.total}</b> {currentUserPoints.is_admin && <LinkToGroupManagement groupId={groupId} />}
        </div>
      )}
    </>
  )
}
